<template>
  <!-- 新电表 电表设置记录 -->
  <table-view
    class="new-electric-meter-set-record-view"
    :total="total"
    :query-info.sync="queryInfo"
    v-loading="loading"
    @reload-table="renderTable"
    style="padding-top: 0;"
  >
    <template #header>
      <view-search-form
        ref="searchFormRef"
        :queryInfo.sync="queryInfo"
        :filter-keys="['roomId']"
        @on-search="renderTable(1)">
        <el-form-item label="记录类型" label-width="80px">
          <el-select
            size="small"
            v-model="queryInfo.rechargeType"
            filterable
            style="width: 150px;"
            @change="handleRechargeType">
            <el-option label="电费充值记录" :value="1" />
            <el-option label="批量赠电记录" :value="2" />
            <el-option label="电表清零记录" :value="3" />
            <el-option label="电表设置记录" :value="4" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="queryInfo.rechargeType!==3" label="状态" label-width="50px">
          <el-select
            size="small"
            v-model="queryInfo.status"
            clearable
            filterable
            style="width: 120px;">
            <el-option
              v-for="{paramValue, paramName} in Object.values(statusMap)"
              :label="paramName"
              :value="Number(paramValue)"
              :key="paramValue" />
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间" label-width="80px">
          <el-date-picker
            type="datetime"
            size="small"
            placeholder=""
            v-model="queryInfo.startDate"
            style="width: 190px"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss:59" />
        </el-form-item>
        <el-form-item label="结束时间" label-width="80px">
          <el-date-picker
            type="datetime"
            size="small"
            v-model="queryInfo.endDate"
            style="width: 190px"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:59" />
        </el-form-item>
      </view-search-form>
      <div class="header-button">
        <!--   仅新电表支持本功能     -->
        <el-button v-permission="['electricMeter:batch:clear']" v-show="parentData.electricType===2" type="danger" plain
                   size="mini" @click="resetMeter">电表清零
        </el-button>
        <!--   仅新电表支持本功能     -->
        <el-button v-show="parentData.electricType===2" icon="el-icon-refresh" plain size="mini"
                   @click="batchRefreshPayStatus">刷新本页支付状态
        </el-button>
      </div>
    </template>
    <!-- body -->
    <el-table :data="tableData" style="width: 100%" border stripe size="small">
      <el-table-column type="index" label="ID" width="50" />
      <el-table-column v-for="(item,index) in tableColumns"
                       :key="index" :prop="item.prop"
                       :label="item.label"
                       :width="item.width"
                       :align="item.align||'center'"
      >
        <template v-slot="{row}">
          <template v-if="item.prop==='stuName'">{{ row.stuName || row.realName || '--'}}
            <el-tag v-if="row.stuName" size="mini">学生</el-tag>
            <el-tag v-if="row.realName" type="success" size="mini">教职工</el-tag>
          </template>
          <template v-else>{{ row[item.prop] }}</template>
        </template>
      </el-table-column>
      <el-table-column prop="afterBalance" label="创建日期" min-width="170">
        <template v-slot="{row}">
          {{ row.createTime|formatDate('YYYY-MM-DD HH:mm') }}
        </template>
      </el-table-column>
      <el-table-column v-if="queryInfo.rechargeType!==3" label="状态" align="center" fixed="right">
        <template v-slot="{row}">
          <p v-if="statusMap[row.status]">
            {{ statusMap[row.status].paramName }}
          </p>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right">
        <template v-slot="{row}">
          <el-button type="primary" v-if="+row.status===1" @click="refreshPayStatus(row)">刷新</el-button>
        </template>
      </el-table-column>
    </el-table>
  </table-view>
</template>

<script>
import tableView from '@/vue/mixins/table-view'
import {
  clearNewElectricMeterApi
} from '@/api/dorm/set-electric-meter-api'
import { pageNewFreeElectricFreeRecordApi, refreshNewMeterPayStatusApi } from '@/api/dorm/free-electric-api'

export default {
  name: 'NewElectricMeterSetRecordView',
  mixins: [tableView],
  props: {
    parentData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visibleTable: true,
      queryInfo: {
        rechargeType: 1,
        roomId: null,
        startDate: null,
        endDate: null,
        status: null,
        pageSize: 10
      },
      taskStatusList: [] // 赠送电费到账状态（queryInfo过滤数据用）
    }
  },
  async mounted() {
  },
  computed: {
    tableColumns() {
      /* 1.电费充值记录
      *  2.批量赠电记录
      * 3.电表清零记录
      * */
      switch (this.queryInfo.rechargeType) {
        case 1:
          return [
            { prop: 'stuName', label: '学生/教职工', width: 200 },
            { prop: 'rechargeAmount', label: '充值金额', width: 120 },
            { prop: 'rechargeNumber', label: '充值电度', width: 120 }
            // { prop: 'beforeNumber', label: '充值前电度', width: 120 },
            // { prop: 'afterNumber', label: '充值后电度', width: 120 }
          ]
        case 2:
          return [
            { prop: 'stuName', label: '学生/教职工', width: 200 },
            { prop: 'rechargeNumber', label: '赠送电度', width: 120 },
            { prop: 'beforeNumber', label: '充值前电度', width: 120 },
            { prop: 'afterNumber', label: '充值后电度', width: 120 }
          ]
        case 3:
          return [
            { prop: 'beforeNumber', label: '清零前电度', width: 120 },
            { prop: 'afterNumber', label: '清零后电度', width: 120 },
            { prop: 'initNumber', label: '初始电量', width: 120, align: 'center' },
            { prop: 'numberOfMeters', label: '电表显示度数', width: 120, align: 'center' }
          ]
        case 4:
          return [
            { prop: 'rechargeNumber', label: '设置值（度）', width: 120 },
            { prop: 'rechargeAmount', label: '价值（元）', width: 120 },
            { prop: 'balance', label: '设置后电度', width: 120 }
          ]
        default:
          return []
      }
    },
    statusMap() {
      switch (this.queryInfo.rechargeType) {
        case 1:
          return {
            1: { paramValue: 1, paramName: '待支付' },
            2: { paramValue: 2, paramName: '支付失败' },
            3: { paramValue: 3, paramName: '缴费成功' },
            4: { paramValue: 4, paramName: '充值成功' }
          }
        case 2:
          return {
            3: { paramValue: 3, paramName: '待赠送' },
            4: { paramValue: 4, paramName: '成功' }
          }
        default:
          return {}
      }
    }
  },
  methods: {
    // 获取设置记录列表
    async renderTable(pageNum) {
      if (!this.parentData.id) return
      this.visibleTable = false
      this.queryInfo.roomId = this.parentData.id
      await this.getTableData(pageNewFreeElectricFreeRecordApi, pageNum)
      await this.$nextTick()
      this.visibleTable = true
    },
    handleRechargeType() {
      this.queryInfo.status = null
      this.renderTable(1)
    },
    /* 新电表 重置电表度数为0 */
    resetMeter() {
      this.$confirm(`确定要把${this.parentData.dormitoryName || null}第${this.parentData.floorNum || 0}层${this.parentData.roomName}【${this.parentData.dormitoryRoomType ? this.parentData.dormitoryRoomType.roomTypeName : '暂无房间'}】的电表度数重置为0度吗？`, '提示').then(async () => {
        try {
          await clearNewElectricMeterApi(this.parentData.id)
          await this.$confirm(`${this.parentData.dormitoryName || null}第${this.parentData.floorNum || 0}层${this.parentData.roomName}【${this.parentData.dormitoryRoomType ? this.parentData.dormitoryRoomType.roomTypeName : '暂无房间'}】的电表清零成功！`, { showCancelButton: false }).then(() => {
            this.renderTable(1)
          })
        } catch (e) {
          console.error(e)
        }
      })
    },
    /* 更新 充值状态 */
    async refreshPayStatus(row) {
      try {
        await refreshNewMeterPayStatusApi(row.id)
        await this.renderTable()
      } catch (e) {
        console.error(e)
      }
    },
    /* 批量更新 充值状态 */
    async batchRefreshPayStatus() {
      try {
        this.loading = true
        const _promises = []
        this.tableData.forEach(item => {
          _promises.push(() => refreshNewMeterPayStatusApi(item.id))
        })
        // await refreshNewMeterPayStatusApi(row.id)
        await Promise.all(_promises.map(func => func()))
        await this.renderTable()
      } catch (e) {
        console.error(e)
      } finally {
        // this.loading = false
      }
    }
  }
}
</script>
<style lang="scss">
.new-electric-meter-set-record-view {
  .el-table {
    .el-table__cell {
      padding: 2px 0;
    }
  }
}
</style>
